import React, { useState } from "react";
import CardContenido from "./CardContenido";
import arrow_up from "../../../../assets/vw/svg/arrow-up.svg";
import arrow_down from "../../../../assets/vw/svg/arrow-down.svg";

const SelectCard = ({
    infoCard,
    aplicaciones,
    index,
    currentActive,
    setCurrentActive
}) => {

    const [showContent, setShowContent] = useState(false);

    const getApp = (idApp) => {
        if (idApp) {
            const objApp = aplicaciones.find((app) => app.idApp === idApp);
            return objApp.nombre;
        } else return "-";
    };

    function localDateTimeToUTC(date) {
        const fechaLocal = new Date(date);

        // Fecha UTC en formato compatible con MYSQL: YYYY-MM-DD HH:MM:SS
        const fechaUTC = fechaLocal.toISOString().slice(0, 19).replace("T", " ");

        return fechaUTC;
    }

    return (
        <div className={"select-card-container"}>
            <div className={"d-flex justify-content-between"}>
                <div className={"d-flex"}>
                    <div className="col-3 container_id bold mr-4 font-weight-bolder">
                        {infoCard.original.id}
                    </div>
                    <div className="col-4 colselect-card-title-one-word font-weight-bolder">
                        {getApp(infoCard.original.app)}
                    </div>
                </div>
                <div>
                    <button
                        className={"button_icon-vw"}
                        onClick={() => {
                            setShowContent(prevState => !prevState);
                            setCurrentActive({ id: index });
                        }}
                    >
                        {
                            (showContent && (currentActive.id !== null && (currentActive.id === index))) ? (
                                <img
                                    src={arrow_up}
                                    alt="arrow-up"
                                    className="px-1"
                                />
                            ): (
                                <img
                                    src={arrow_down}
                                    alt="arrow-down"
                                    className="px-1"
                                />
                            )
                        }
                    </button>
                </div>

            </div>
            {
                (showContent && (currentActive.id !== null && (currentActive.id === index))) && (
                    <CardContenido
                        infoCard={infoCard}
                        id={index}
                        setShowContent={setShowContent}
                        getApp={getApp}
                        localDateTimeToUTC={localDateTimeToUTC}
                    />
                )
            }
        </div>
    );
}

export default SelectCard;